<template>
  <v-container class="contract-detail-page" fluid tag="section">
    <div  v-if="!data">
      <img :src="require('@/assets/images/empty.png')" height="300" :width="$isMobile ? '100%' : 300"/>
    </div>
    <div v-else>
      <div class="contract" v-if="item && item.again === 1">
        <img :src="require('@/assets/images/contract.png')"/>
      </div>

      <v-row>
        <v-col cols="12" :md="mini ? 3 : 4" :sm='6' :class="$isMobile ? 'size-13' : ''">
          客户名称：<span class="font-weight-black">{{data.customer === null || data.customer === undefined  ? '' : data.customer.name}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 3 : 4" sm='6' :class="$isMobile ? 'size-13' : ''">
          订单编号：<span class="font-weight-black">{{data.serialNumber}}</span>
        </v-col>
        <v-col cols="12" :md="mini ? 6 : 4" sm='6' :class="$isMobile ? 'size-13' : ''">
          签订项目：
          <v-chip small class="ml-0 mt-n1" outlined color="primary">
            {{data.year}}年<span v-if="bookkeeping">{{item.month}}月开始</span>
          </v-chip>
          <span class="font-weight-black">{{data.product === null || data.product === undefined ? '' : data.product.name}}</span>
        </v-col>
      </v-row>

      <v-row v-if="data.bookkeepingDic && data.bookkeepingDic.length > 0">
        <v-col cols="12" :class="$isMobile ? 'size-13' : ''">
          附加服务：
          <v-chip v-for="(item, idx) in data.bookkeepingDic" dark color="primary" small class="mr-1" :key="idx">
            {{item.name}}
          </v-chip>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          签订公司：<span class="font-weight-black">
            {{data.signDic  === null || data.signDic === undefined  ? '' : data.signDic.name}}
            <span v-if="data.channelName" class="font-weight-black">({{data.channelName}})</span>
          </span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          签订人员：
          <v-chip v-for="(item, idx) in data.signUserList" small class="mr-1" outlined :key="idx">
            {{item.name}}
          </v-chip>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" :class="$isMobile ? 'size-13' : ''">
          签订时间：<span class="font-weight-black">{{data.signTime | formatDay}}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          {{bookkeeping ? '服务时长' : '签订数量'}}：<span class="font-weight-black">{{data.productNumber}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          产品定价：<span class="font-weight-black">{{data.unitPrice}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" :class="$isMobile ? 'size-13' : ''">
          签单单价：<span class="font-weight-black" v-if="showPrice(data.contactsPersonList)">{{data.signUnitPrice}}</span>
        </v-col>
      </v-row>

      <v-row v-if="data.signPrice - data.mediatorPrice < data.unitPrice * data.productNumber * 0.8">
        <v-col :class="$isMobile ? 'size-13' : ''"><span class="font-weight-black red--text">提示：本合同&nbsp;合同金额减去居间人费 小于 产品定价乘以签定数量的80%</span></v-col>
      </v-row>

      <v-row v-if="data.signPrice - data.mediatorPrice < data.unitPrice * data.productNumber &&
                  data.signPrice - data.mediatorPrice >= data.unitPrice * data.productNumber * 0.8">
        <v-col :class="$isMobile ? 'size-13' : ''"><span class="font-weight-black red--text">提示：本合同&nbsp;合同金额减去居间人费 高于 产品定价乘以签定数量的80% 但低于 100%</span></v-col>
      </v-row>

      <v-row>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          合同金额：<span class="font-weight-black" v-if="showPrice(data.contactsPersonList)">{{data.signPrice}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          合同状态：<span class="font-weight-black">{{data.stateDic  === null || data.stateDic === undefined  ? '' : data.stateDic.name}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" :class="$isMobile ? 'size-13' : ''">
          收费比例：<span class="font-weight-black">{{data.chargeRatio}}</span>
        </v-col>
      </v-row>


      <v-row>
        <v-col cols="12" :md="mini ? 6 : 8" :class="$isMobile ? 'size-13' : ''">
          合同类型：<span class="font-weight-black">{{data.typeDic  === null || data.typeDic === undefined  ? '' : data.typeDic.name}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" :class="$isMobile ? 'size-13' : ''">
          居间人员：<span class="font-weight-black">{{data.mediatorName}}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          居间人费：<span class="font-weight-black" v-if="showPrice(data.contactsPersonList)">{{data.mediatorPrice}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          其他费用：<span class="font-weight-black" v-if="showPrice(data.contactsPersonList)">{{data.otherPrice}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" :class="$isMobile ? 'size-13' : ''">
          合同绩效：<span class="font-weight-black" v-if="showPrice(data.contactsPersonList)">{{data.profitPrice}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          人员级别：<span class="font-weight-black">{{data.levelDic  === null || data.levelDic === undefined   ? '' : data.levelDic.name}}</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          提成比例：<span class="font-weight-black" v-if="showPrice(data.contactsPersonList)">{{data.commissionRatio}}%</span>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" :class="$isMobile ? 'size-13' : ''">
          提成金额：<span class="font-weight-black" v-if="showPrice(data.contactsPersonList)">{{data.ratioPrice}}</span>
        </v-col>
      </v-row>

      <v-row>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          负责人员：
          <v-chip v-for="(item, idx) in data.contactsPersonList" small class="mr-1" outlined :key="idx">
            {{item.name}}
          </v-chip>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
          协同人员 ：
          <v-chip v-for="(item, idx) in data.assistPersonList" small class="mr-1" outlined :key="idx">
            {{item.name}}
          </v-chip>
        </v-col>
        <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 6 : 4" :class="$isMobile ? 'size-13' : ''">
          合同版本：<span class="font-weight-black">v{{data.version}}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" :class="$isMobile ? 'size-13' : ''">
          备注信息：<span class="font-weight-black">{{data.remark}}</span>
        </v-col>
      </v-row>
      <v-row v-if="showPrice(data.contactsPersonList)">
        <v-col cols="12" :class="$isMobile ? 'size-13' : ''">
          附件信息：
          <span v-if="data.fileName" class="font-weight-black">
            <v-btn text class="pl-0" color="primary" small @click="view(data.filePath)">
              {{data.fileName.substring(data.fileName.lastIndexOf('/')+1,data.fileName.length)}}
            </v-btn>
          </span>
          <span v-else class="font-weight-black">无附件信息</span>
        </v-col>
      </v-row>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="30"></v-progress-circular>
    </v-overlay>
   </v-container>
</template>

<script>
  import { getById } from '@/api/contract/index.js'

  export default {
    name: 'ContractDetail',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      },
      lazy: {
        type: Boolean,
        default: false
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        loading: false,
        data: this.item,
        fileModal: { show: false }
      }
    },
    methods: {
      loadData () {
        if (this.item && this.item.id) {
          this.loading = true
          getById(this.item.id).then(res => {
            if (res.status === 200) {
              this.data = res.data
            }
            this.loading = false
          })
        }
      },
      showPrice (list) {
        let boo = false
        if (list && list.size > 0) {
          list.forEach(p => {
            boo = p.id === this.$store.state.userInfo.id
          });
        }
        return boo || this.$_has('con-contract-price') || this.$store.state.userInfo.roleIds.indexOf(1) !== -1
      },
      view (path) {
        if (path) {
          window.open(
            path,
            "_blank"
          );
        }
      }
    },
    computed: {
      bookkeeping () {
        return this.$constants.ProductType.Bookkeeping.indexOf(this.item.productId) !== -1
      }
    },
    created () {
      if (this.lazy) {
        this.loadData()
      }
    }
  }
</script>

<style lang="scss" scoped>
.contract {
  position: absolute;
  z-index: 1;
  left: 270px;
  top: 55px;
  img{
    width: 120px;
    -moz-transform: rotate(-30deg);
    -webkit-transform: rotate(-30deg);
  }
}
</style>
